type Exterior = {
  endereco?: string | null;
  cidade?: string | null;
  regiao?: string | null;
  codigoPostal?: string | null;
  pais?: string | null;
  telefone?: string | null;
};

/** `{endereco} – {cidade}[, {regiao}][ {codigoPostal}] – {pais}[ · Tel. {telefone}]` (spec 11 §6.3). */
export function formatarEnderecoExterior(e: Exterior): string {
  const endereco = (e.endereco ?? '').replace(/\s*\n\s*/g, ', ').trim();
  const regiao = e.regiao?.trim() ? `, ${e.regiao.trim()}` : '';
  const postal = e.codigoPostal?.trim() ? ` ${e.codigoPostal.trim()}` : '';
  const tel = e.telefone?.trim() ? ` · Tel. ${e.telefone.trim()}` : '';
  return `${endereco} – ${e.cidade ?? ''}${regiao}${postal} – ${e.pais ?? ''}${tel}`;
}
